document.addEventListener('DOMContentLoaded', function () {
  var sleep = 100;
  var productGridContainer = document.querySelector('.product-grid-container');
  var loadMoreButton = document.getElementById('loadMoreButton');
  var isInitialLoad = true;

  if (!productGridContainer || !loadMoreButton) return;

  function getShowLimit() {
    var fallbackLimit = 16;
    if (typeof show_first === 'undefined') return fallbackLimit;

    var limit = parseInt(show_first, 10);
    return isNaN(limit) ? fallbackLimit : limit;
  }

  function showElements(count) {
    var elementsToShow = document.querySelectorAll('.scroll-infinite.d-none');
    for (var i = 0; i < Math.min(count, elementsToShow.length); i++) {
      elementsToShow[i].classList.remove('d-none');
    }
  }

  function handleEvent() {
    if (isInitialLoad) return;
    setTimeout(() => {
      showElements(getShowLimit());
      hideLoadButtonIfNoMoreElements();
    }, sleep);
  }

  function countElements() {
    var elementsCount = document.querySelectorAll('.product-grid-container .scroll-infinite').length;

    if (document.querySelector('#ProductCountDesktop')) {
      document.querySelector('#ProductCountDesktop').innerHTML = elementsCount + ' productos';
    }
    if (document.querySelector('#ProductCount')) {
      document.querySelector('#ProductCount').innerHTML = elementsCount + ' productos';
    }
  }

  function hideLoadButtonIfNoMoreElements() {
    if (document.querySelectorAll('.scroll-infinite.d-none').length === 0) {
      loadMoreButton.style.display = 'none';
    }
  }

  loadMoreButton.addEventListener('click', function () {
    showElements(getShowLimit());
    hideLoadButtonIfNoMoreElements();
  });

  var observer = new MutationObserver(function (mutationsList) {
    for (var mutation of mutationsList) {
      if (mutation.type === 'childList') {
        if (!isInitialLoad) {
          handleEvent();
          hideLoadButtonIfNoMoreElements();
        }
      }
    }
  });

  var observerConfig = { childList: true, subtree: true };
  observer.observe(productGridContainer, observerConfig);

  function initializeScript() {
    observer.disconnect();

    var eventElements = [
      {
        selector:
          '.facets input[type="checkbox"], .facets-wrapper input[type="checkbox"], .mobile-facets input[type="checkbox"]',
        event: 'click',
      },
      { selector: '#SortBy, #SortBy-mobile', event: 'change' },
      { selector: '.active-facets__button-remove', event: 'click' },
      { selector: '.active-facets a, .mobile-facets__clear', event: 'click' },
    ];

    eventElements.forEach(function (element) {
      var elements = document.querySelectorAll(element.selector);
      elements.forEach(function (item) {
        item.addEventListener(element.event, handleEvent);
      });
    });

    showElements(getShowLimit());
    hideLoadButtonIfNoMoreElements();
    if (typeof checkProductQty === 'function') {
      checkProductQty();
    }
    isInitialLoad = false;

    observer.observe(productGridContainer, observerConfig);

    countElements();
  }

  initializeScript();
});
